export default "__VITE_ASSET__DgT5LunJ__"